
import {StoreControl} from "../../controls/base/StoreControl";


import {func} from "prop-types";
import {SingleEvent} from "shared/core/Events/SingleEvent";
import {RNReflect} from "shared/core/Utilities/Reflect";


export abstract class StoreBase {

    IsDirty:boolean=false;
    private _fields:StoreControl<any,any>[]=[];
    private _defaultValuesLoaded:boolean;
    public ValueChanged:SingleEvent<string>;
    constructor()
    {
        this._fields=[];
        this.ValueChanged=new SingleEvent();
        this._defaultValuesLoaded=false;
    }
    public AddField(field:StoreControl<any,any>){
        this._fields.push(field);
    }

    public RemoveField(field:StoreControl<any,any>)
    {
        let index=this._fields.indexOf(field);
        if(index>=0)
            this._fields.splice(index,1);
    }


    public Subscribe(reference:any,callback:(string)=>void)
    {
        this.ValueChanged.Subscribe(reference,callback);
    }

    public Unsubscribe(reference:any)
    {
        this.ValueChanged.Unsubscribe(reference);
    }


    public GetValue(property:keyof this|any)
    {
        return this[property];
    }

    public SetValue(property:Exclude<keyof this,keyof StoreBase|"LoadDefaultValues">|any,value:any)
    {
        this.ParseAndSetValue(property,value);
        this.ValueChanged.Publish(property);
    }

    protected abstract LoadDefaultValues();

    public Merge(itemToLoad:(Partial<Omit<this,keyof StoreBase>>)|any=null){
        if(!this._defaultValuesLoaded) {
            this.LoadDefaultValues();
            this._defaultValuesLoaded=true;
        }
        if(itemToLoad==null) {
            this.SetAutoIncrementIds();
            return this;
        }

        for(let propertyName in itemToLoad)
        {
            if((this as any).hasOwnProperty(propertyName))
            {
                let value:any=itemToLoad[propertyName];
                this.ParseAndSetValue(propertyName,value);

            }

        }


        this.SetAutoIncrementIds();
        return this;
    }

    public SetAutoIncrementIds()
    {
        for(let propertyName in this)
        {
            if(!(this as any).hasOwnProperty(propertyName))
                continue;

            let autoIncrementId=null;
            if(RNReflect.getMetadata('StoreAutoIncrement',this,propertyName)==null)
                autoIncrementId=null;
            else
                autoIncrementId=RNReflect.getMetadata('StoreAutoIncrement',this,propertyName);
            let value:any=this[propertyName];
            if(autoIncrementId!=null)
            {
                let dictionary:{Id:string,LastNumber:number}[]=(window as any).StoreAutoIncrementDictionary;
                let currentAutoIncrementItem=dictionary.find(x=>x.Id==autoIncrementId);
                if(currentAutoIncrementItem==null)
                    throw new Error('Auto increment for property '+propertyName+' does not exist');


                if(value==null||value===0) {
                    currentAutoIncrementItem.LastNumber++;
                    (this as any)[propertyName] = currentAutoIncrementItem.LastNumber;
                }else
                {
                    let usedId=parseInt(value.toString());
                    if(isNaN(usedId))
                        throw new Error('Used id for property '+propertyName+' is not a valid number, was:'+value.toString());
                    (this as any)[propertyName] = usedId;

                    currentAutoIncrementItem.LastNumber=Math.max(usedId,currentAutoIncrementItem.LastNumber);
                }
            }
        }
    }

    private ParseAndSetValue(propertyName,value:any){
        let currentValue=this[propertyName];
        let loaderValue=this.GetValueFromLoader(propertyName,value);
        if(loaderValue!=null)
        {
            (this as any)[propertyName]=loaderValue;
            return;
        }

        if(currentValue!=null&&currentValue.hasOwnProperty('_fields')&&currentValue.hasOwnProperty('_defaultValuesLoaded')) {
            if(value!=null&&value.hasOwnProperty('_fields')&&value.hasOwnProperty('_defaultValuesLoaded'))
                (this as any)[propertyName]=value;
            else
                (this as any)[propertyName].Merge(value);
            return;
        }



        if(typeof currentValue=='number') {
            (this as any)[propertyName] = parseFloat(value==null?0:value.toString());
            return;
        }

        if(typeof currentValue=='boolean')
        {
            if(!isNaN(value))
                (this as any)[propertyName]=value===true||parseFloat(value)==1;
            else
                (this as any)[propertyName]=value=='true';
            return;
        }


        if(typeof currentValue=='string')
        {
            (this as any)[propertyName]=value;
            return;
        }

        if(currentValue!=null&& currentValue.constructor==Array)
        {

            if(RNReflect.getMetadata('StoreType',this,propertyName)==null)
                throw 'Property '+propertyName+' of class '+(this as any).constructor.name+' is an array but does not have the OptionType decorator implemented';

            let type=RNReflect.getMetadata('StoreType',this,propertyName);
            (this[propertyName] as any)=[];
            if((type as any)==String||(type as any)===Object)
            {
                this[propertyName]=value;
                return;
            }

            if((type as any)==Number)
            {
                this[propertyName]=value;
                return;
            }

            for(let newValueItem of value)
            {
                if(newValueItem!=null&&newValueItem.hasOwnProperty('_fields')&&newValueItem.hasOwnProperty('_defaultValuesLoaded'))
                    (this[propertyName] as any).push(newValueItem);
                else
                    (this[propertyName] as any).push(new (type as any)().Merge(newValueItem));
            }

            return;
        }

        if(currentValue==null&&RNReflect.getMetadata('StoreType',this,propertyName)!=null)
        {
            if(value==null)
                return;
            let store=RNReflect.getMetadata('StoreType',this,propertyName);
            if(store.prototype instanceof StoreBase) {
                this[propertyName] = new (store as any)().Merge(value);
                return;
            }
        }

        let type=RNReflect.getMetadata('StoreType',this,propertyName);

        if(type==Object)
        {
            this[propertyName]=value;
            return;
        }



        throw 'Could not process type '+ typeof currentValue+' of '+propertyName;
    }

    protected GetValueFromLoader(property:keyof this,value:any):any
    {
        return null;

    }


    public Validate(){
        let isValid=true;
        for(let field of this._fields)
        {
            if(!field.Validate())
                isValid=false;
        }

        return isValid;
    }


    public ToObject(){
        let object=JSON.parse(JSON.stringify(this,(name,value)=>{
            if(['_fields','_defaultValuesLoaded','IsDirty','ValueChanged'].indexOf(name)>=0||typeof value=="function")
                return undefined;
            return value;
        }));
        return object;
    }



    private SerializeObject(object: this):any {
        let fieldsToRemove=['_fields','_defaultValuesLoaded','IsDirty'];

        for(let property in object)
        {
            let item=object[property];
            if(fieldsToRemove.indexOf(property)>=0||typeof item=='function') {
                delete object[property];
                continue;
            }

            if(Array.isArray(item))
            {
                this.SerializeArray(item);
            }

            if(typeof item=='object')
            {
                item=this.SerializeObject(item as any);
            }

        }

        return object;
    }

    private SerializeArray(array: any[]) {
        for(let i=0;i<array.length;i++)
        {
            let item=array[i];
            if(Array.isArray(item))
                this.SerializeArray(item);

            if(typeof item =='object')
                array[i]=this.SerializeObject(item);
        }
    }
}


const StoreKey='StoreType';

export function StoreDataType(type:typeof StoreBase|object):any {

    return RNReflect.metadata('StoreType',type);

}


const StoreAutoIncrementKey='StoreAutoIncrement';

if((window as any).StoreAutoIncrementDictionary==null)
    (window as any).StoreAutoIncrementDictionary=[];


export function StoreAutoIncrement(uniqueId:any):any {
    let dictionary:{Id:string,LastNumber:number}[]=(window as any).StoreAutoIncrementDictionary;
    dictionary.push({Id:uniqueId,LastNumber:0});
    return RNReflect.metadata('StoreAutoIncrement',uniqueId);

}



